import React from 'react';
import { MapContainer, TileLayer, Marker, Popup, Circle } from 'react-leaflet';
import { Icon, divIcon } from 'leaflet';
import { siteConfig } from '../../data/config';
import 'leaflet/dist/leaflet.css';

// Fix for default marker icon
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
});

// Custom marker icons
const createCustomIcon = (color, isMain = false) => {
  const size = isMain ? 16 : 12;
  return divIcon({
    className: 'custom-marker',
    html: `<div style="
      background-color: ${color};
      width: ${size}px;
      height: ${size}px;
      border-radius: 50%;
      border: 3px solid white;
      box-shadow: 0 2px 6px rgba(0,0,0,0.3);
    "></div>`,
    iconSize: [size, size],
    iconAnchor: [size/2, size/2],
  });
};

const ServiceAreaMap = () => {
  const { mapCenter, mapZoom, serviceMarkers } = siteConfig;

  return (
    <div 
      className="h-[400px] md:h-[500px] w-full rounded-xl overflow-hidden border-2 border-white shadow-lg"
      data-testid="service-area-map"
    >
      <MapContainer
        center={mapCenter}
        zoom={mapZoom}
        style={{ height: '100%', width: '100%' }}
        scrollWheelZoom={false}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
          url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
        />
        
        {/* Service area circle */}
        <Circle
          center={mapCenter}
          radius={25000}
          pathOptions={{
            color: '#0B67C2',
            fillColor: '#0B67C2',
            fillOpacity: 0.1,
            weight: 2,
          }}
        />

        {/* Markers */}
        {serviceMarkers.map((marker, index) => (
          <Marker
            key={index}
            position={[marker.lat, marker.lng]}
            icon={createCustomIcon(
              marker.airport ? '#FFD24D' : marker.main ? '#0B67C2' : '#6B7280',
              marker.main
            )}
          >
            <Popup>
              <div className="font-semibold text-foreground">{marker.name}</div>
              {marker.airport && (
                <div className="text-sm text-muted-foreground">Aéroport YUL</div>
              )}
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default ServiceAreaMap;
